export default __webpack_public_path__ + "5a064389b40b0197924a626536cfa732.woff";